import React from 'react'

function Review() {
  return (
    <div className="container mx-auto px-4 py-8 ">
      <h2 className="text-center font-semibold text-[#1865a5] tracking-wide uppercase">
        Location & Reviews
      </h2>
      <p className="text-center mt-2 text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
        Where to Find Us & What People Say
      </p>
      <iframe
        src="/elfsight.html"
        style={{
          border: 'none',
          width: '100%',
          height: '270px',
          overflowY: 'hidden',
        }}
        title="Reviews"
      />
    </div>
  )
}

export default Review
